<div id="chart-price-history" style="min-height: 300px; max-height: 350px;"></div>